// eslint-disable-next-line no-restricted-imports
import { Skeleton, Box, Text } from '@mantine/core';
import styled from '@emotion/styled';

import { FEATURE } from '~/common/enums/feature.enum';
import repeat from '~/common/utils/repeat';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';
import ConnectedContestCard from '~/domains/contest/domains/common/components/ContestCard/ConnectedContestCard';
import { getIsRestrictedInLocation } from '~/domains/contest/domains/common/utils/getIsRestrictedInLocation';

import { CardContainer, CardGrid } from './styles';

interface GridLobbyProps {
  data: Contest[];
  isLoading: boolean;
}

const EmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 520px;
  width: 100%;
`;

function GridLobby({ data, isLoading }: GridLobbyProps) {
  const isShowContestThumbnailEnabled = useIsFeatureEnabled(FEATURE.SHOW_CONTEST_ITEM_THUMBNAIL);
  const isCountdownPillEnabled = useIsFeatureEnabled(FEATURE.ENABLE_CONTEST_COUNTDOWN_TIMER);

  if (isLoading)
    return (
      <CardContainer>
        <CardGrid>
          {repeat(5, (index) => (
            <Skeleton key={index} height={140} radius="md" />
          ))}
        </CardGrid>
      </CardContainer>
    );

  const columns = data
    ? data.map((contest) => (
        <ConnectedContestCard
          key={contest.id}
          contest={contest}
          isContestThumbnailShown={isShowContestThumbnailEnabled}
          isNotAllowedInLocation={getIsRestrictedInLocation(contest)}
          isCountdownPillEnabled={isCountdownPillEnabled}
          isBannerEnabled
        />
      ))
    : [];

  return (
    <CardContainer>
      <CardGrid>
        {columns.length > 0 ? (
          columns
        ) : (
          <EmptyStateContainer>
            <Text size="lg" c="dimmed">
              Nothing found
            </Text>
          </EmptyStateContainer>
        )}
      </CardGrid>
    </CardContainer>
  );
}

export default GridLobby;
